export default "https://cdn-static.gokick.com/assets/30adf10d1d1967cb40501bfdbefb418f6cea25a6/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";